import { app } from "../../main";
import axios from "axios";
import i18n from "../../lang/lang";

function initialState() {
  return {
    lang: "labels",
    availableLanguages: [],
  };
}

const state = initialState;

const getters = {
  getLang: (state) => state.lang,
  getAvailableLangs: (state) => {
    const result = state.availableLanguages
      ?.filter((lang) => lang.active)
      .map((lang) => lang.id);
    return result;
  },
  getAllLangs: (state) => state.availableLanguages,
};

const actions = {
  async setLangNew({ commit }, payload) {
    // Descarga asincronicamente los textos
    if (payload in i18n.messages) {
      commit("SET_LANG", payload);
    } else {
      try {
        const res = await axios.get(`/Langs/${payload}/language.json`); // Dejar esta linea para cargar los idiomas desde el endpoint
        app.$i18n.setLocaleMessage(payload, res.data);
        commit("SET_LANG", payload);
      } catch (e) {
        console.log(e);
      }
    }
  },
  async availableLanguages({ commit }) {
    try {
      const resp = await axios.get(`/Langs/AvailableLanguages`);
      resp.data && commit("SET_AVAILABLE_LANGS", resp.data);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  SET_LANG: (state, payload) => {
    state.lang = payload;
    app.$i18n.locale = payload;
  },
  SET_LABEL_LANG: (state) => {
    app.$i18n.setLocaleMessage("labels", {});
    state.lang = "labels";
    app.$i18n.locale = "labels";
    app.$i18n._localeChainCache.labels = [];
    console.log(app.$i18n);
  },
  SET_AVAILABLE_LANGS: (state, payload) => {
    state.availableLanguages = payload;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
